<template>
  <div class="subpage">
    <div class="page-navbar">
      <div class="page-navbar-wrapper">
        <ul>
          <li
            :data-menuanchor="navbar.anchor"
            :key="i"
            @click="moveToSection(i)"
            v-for="(navbar, i) in this.safety.text.pageNavbar"
          >
            <span>{{ navbar.name }}</span>
          </li>
        </ul>
        <div class="scroll-downs">
          <div class="mousey">
            <div class="scroller"></div>
          </div>
        </div>
      </div>
    </div>
    <full-page :options="options" id="fullpage" ref="fullpage">
      <div
        class="subpage-header section fp-auto-height-responsive"
        data-anchor="safety"
      >
        <div class="section-container">
          <div class="section-wrapper">
            <h2
              class="uppercase header"
              data-aos="text-focus-in"
              data-aos-duration="500"
            >
              <span>Technologie</span>
              zapewniające wszechstronne bezpieczeństwo
            </h2>
            <p
              class="description"
              data-aos="text-focus-in"
              data-aos-delay="150"
              data-aos-duration="500"
            >
              {{ this.safety.text.headerDesc }}
            </p>
            <!--<v-btn
              :class="'mmc-blue background'"
              class="gallery"
              data-aos="text-focus-in"
              data-aos-delay="300"
              data-aos-duration="1000"
              data-selector=".movie"
              v-ripple="{ class: 'ripple-blue' }"
            >
              <span
                class="movie"
                data-src="https://www.youtube.com/watch?v=YlBg6FNu26U"
              ></span>
              <i class="fas fa-play"></i>
              {{ this.safety.text.headerButton }}
            </v-btn>-->
          </div>
        </div>
      </div>
      <div
        class="text-and-slide section fp-auto-height-responsive"
        data-anchor="FCM"
      >
        <div class="section-container">
          <div class="section-text">
            <h2
              class="uppercase header"
              data-aos="fade-down"
              data-aos-duration="500"
            >
              {{ this.safety.text.safetyRoadHeader }}
            </h2>
            <h5
              class="uppercase header-sub"
              data-aos="zoom-in"
              data-aos-delay="150"
              data-aos-duration="500"
            >
              {{ this.safety.text.safetyRoadSubHeader }}
            </h5>
            <p
              class="description"
              data-aos="zoom-in"
              data-aos-delay="300"
              data-aos-duration="500"
            >
              {{ this.safety.text.safetyRoadDesc }}
            </p>
            <div
              class="buttons flex-start"
              data-aos="text-focus-in"
              data-aos-delay="450"
              data-aos-duration="500"
            >
              <v-btn
                :class="
                  safety.safetyRoadSliderIndex === 0
                    ? 'mmc-red text'
                    : 'only-text'
                "
                v-ripple="{ class: 'ripple-red' }"
                @click="goToSafetyRoadPage(0, 'dangerOfCollision')"
                >Niebezpieczeństwo kolizji</v-btn
              >
              <v-btn
                :class="
                  safety.safetyRoadSliderIndex === 1
                    ? 'mmc-red text'
                    : 'only-text'
                "
                v-ripple="{ class: 'ripple-red' }"
                @click="goToSafetyRoadPage(1, 'highDangerOfCollision')"
                >Duże niebezpieczeństwo kolizji</v-btn
              >
              <v-btn
                :class="
                  safety.safetyRoadSliderIndex === 2
                    ? 'mmc-red text'
                    : 'only-text'
                "
                v-ripple="{ class: 'ripple-red' }"
                @click="goToSafetyRoadPage(2, 'extremelyDangerOfCollision')"
                >Ekstremalne niebezpieczeństwo kolizji</v-btn
              >
            </div>
          </div>
          <div class="section-slider">
            <swiper
              :options="safety.safetySlider"
              class="swiper slider-flex"
              ref="safetyRoad"
            >
              <swiper-slide class="slider-item">
                <video-background
                  :src="require('@/assets/videos/Danger_of_collision.mp4')"
                  :poster="
                    require('@/assets/images/safety/video-slider-first.png')
                  "
                  :autoplay="false"
                  :loop="false"
                  @ready="sliderVideoStart('dangerOfCollision', 'safetyRoad')"
                  @ended="sliderVideoStart('dangerOfCollision', 'safetyRoad')"
                  ref="dangerOfCollision"
                  data-ref="dangerOfCollision"
                >
                  <p
                    class="p-bold"
                    data-aos="zoom-in"
                    data-aos-delay="600"
                    data-aos-duration="500"
                  >
                    <b>Ostrzeżenie + wspomaganie hamowania</b>
                  </p>
                </video-background>
              </swiper-slide>
              <swiper-slide class="slider-item">
                <video-background
                  :src="require('@/assets/videos/High_danger_of_collision.mp4')"
                  :poster="
                    require('@/assets/images/safety/video-slider-first.png')
                  "
                  :autoplay="false"
                  :loop="false"
                  @ready="
                    sliderVideoStart('highDangerOfCollision', 'safetyRoad')
                  "
                  @ended="
                    sliderVideoStart('highDangerOfCollision', 'safetyRoad')
                  "
                  ref="highDangerOfCollision"
                  data-ref="highDangerOfCollision"
                >
                  <p
                    class="p-bold"
                    data-aos="zoom-in"
                    data-aos-delay="600"
                    data-aos-duration="500"
                  >
                    <b>Ostrzeżenie + automatyczne hamowanie</b>
                  </p></video-background
                >
              </swiper-slide>
              <swiper-slide class="slider-item">
                <video-background
                  :src="
                    require('@/assets/videos/Extremely_high_danger_of_collision.mp4')
                  "
                  :poster="
                    require('@/assets/images/safety/video-slider-first.png')
                  "
                  :autoplay="false"
                  :loop="false"
                  @ready="
                    sliderVideoStart('extremelyDangerOfCollision', 'safetyRoad')
                  "
                  @ended="
                    sliderVideoStart('extremelyDangerOfCollision', 'safetyRoad')
                  "
                  ref="extremelyDangerOfCollision"
                  data-ref="extremelyDangerOfCollision"
                >
                  <p
                    class="p-bold"
                    data-aos="zoom-in"
                    data-aos-delay="600"
                    data-aos-duration="500"
                  >
                    <b>Ostrzeżenie + automatyczne hamowanie z wysoką siłą</b>
                  </p>
                  ></video-background
                >
              </swiper-slide>
            </swiper>
          </div>
        </div>
      </div>
      <div
        class="text-and-slide section fp-auto-height-responsive"
        data-anchor="ACC"
      >
        <div class="section-container">
          <div class="section-text text-right">
            <h2
              class="uppercase header"
              data-aos="fade-down"
              data-aos-duration="500"
            >
              {{ this.safety.text.safetyAllHeader }}
            </h2>
            <h5
              class="uppercase header-sub"
              data-aos="zoom-in"
              data-aos-delay="150"
              data-aos-duration="500"
            >
              {{ this.safety.text.safetyAllSubHeader }}
            </h5>
            <p
              class="description"
              data-aos="zoom-in"
              data-aos-delay="300"
              data-aos-duration="500"
            >
              {{ this.safety.text.safetyAllDesc }}
            </p>
            <div
              class="buttons"
              data-aos="text-focus-in"
              data-aos-delay="450"
              data-aos-duration="500"
            >
              <v-btn
                :class="
                  safety.safetyAllSliderIndex === 0
                    ? 'mmc-red text'
                    : 'only-text'
                "
                v-ripple="{ class: 'ripple-red' }"
                @click="goToSafetyAllPage(0, 'noVehicleInFront')"
                >Brak pojazdu z przodu</v-btn
              >
              <v-btn
                :class="
                  safety.safetyAllSliderIndex === 1
                    ? 'mmc-red text'
                    : 'only-text'
                "
                v-ripple="{ class: 'ripple-red' }"
                @click="goToSafetyAllPage(1, 'vehicleInFront')"
                >Pojazd z przodu</v-btn
              >
              <v-btn
                :class="
                  safety.safetyAllSliderIndex === 2
                    ? 'mmc-red text'
                    : 'only-text'
                "
                v-ripple="{ class: 'ripple-red' }"
                @click="goToSafetyAllPage(2, 'slowStopping')"
                >Pojazd z przodu (zwalnia/zatrzymuje się)</v-btn
              >
            </div>
          </div>
          <div class="section-slider">
            <swiper
              :options="safety.safetySlider"
              class="swiper slider-flex"
              ref="safetyAll"
            >
              <swiper-slide class="slider-item">
                <video-background
                  :src="require('@/assets/videos/No_vechicle_in_front.mp4')"
                  :poster="
                    require('@/assets/images/safety/video-slider-second.png')
                  "
                  :autoplay="false"
                  :loop="false"
                  @ready="sliderVideoStart('noVehicleInFront', 'safetyAll')"
                  @ended="sliderVideoStart('noVehicleInFront', 'safetyAll')"
                  ref="noVehicleInFront"
                  data-ref="noVehicleInFront"
                >
                  <p
                    class="p-bold right"
                    data-aos="zoom-in"
                    data-aos-delay="600"
                    data-aos-duration="500"
                  >
                    <b
                      >Wybrana prędkość jest utrzymywana nawet po zdjęciu stopy
                      z pedału przyspieszenia.</b
                    >
                  </p>
                </video-background>
              </swiper-slide>
              <swiper-slide class="slider-item">
                <video-background
                  :src="require('@/assets/videos/Vechicle_in_front.mp4')"
                  :poster="
                    require('@/assets/images/safety/video-slider-second.png')
                  "
                  :autoplay="false"
                  :loop="false"
                  @ready="sliderVideoStart('vehicleInFront', 'safetyAll')"
                  @ended="sliderVideoStart('vehicleInFront', 'safetyAll')"
                  ref="vehicleInFront"
                  data-ref="vehicleInFront"
                >
                  <p
                    class="p-bold right"
                    data-aos="zoom-in"
                    data-aos-delay="600"
                    data-aos-duration="500"
                  >
                    <b>Wybrana odległość między pojazdami jest utrzymywana.</b>
                  </p></video-background
                >
              </swiper-slide>
              <swiper-slide class="slider-item">
                <video-background
                  :src="
                    require('@/assets/videos/Vechicle_in_front_slowing_stopping.mp4')
                  "
                  :poster="
                    require('@/assets/images/safety/video-slider-second.png')
                  "
                  :autoplay="false"
                  :loop="false"
                  @ready="sliderVideoStart('slowStopping', 'safetyAll')"
                  @ended="sliderVideoStart('slowStopping', 'safetyAll')"
                  ref="slowStopping"
                  data-ref="slowStopping"
                >
                  <p
                    class="p-bold right"
                    data-aos="zoom-in"
                    data-aos-delay="600"
                    data-aos-duration="500"
                  >
                    <b
                      >Kiedy pojazd poprzedzający zwalnia lub zatrzymuje się,
                      ACC zmniejsza prędkość lub zatrzymuje samochód.</b
                    >
                  </p></video-background
                >
              </swiper-slide>
            </swiper>
          </div>
        </div>
      </div>
      <div
        class="movie-section section fp-auto-height-responsive"
        data-anchor="LDW"
      >
        <video-background
          :src="require('@/assets/videos/ldw.mp4')"
          :poster="require('@/assets/images/safety/ldw-background.jpg')"
          :autoplay="false"
          :loop="false"
          @ready="pauseOnStart('ldw')"
          @ended="endedVideo('ldw')"
          ref="ldw"
          data-ref="ldw"
        >
          <div class="section-wrapper">
            <h5
              class="uppercase header-sub"
              data-aos="fade-down"
              data-aos-duration="500"
            >
              {{ this.safety.text.ldwSubHeader }}
            </h5>
            <h2
              class="uppercase header"
              data-aos="zoom-in"
              data-aos-delay="150"
              data-aos-duration="500"
            >
              {{ this.safety.text.ldwHeader }}
            </h2>
            <p
              class="description"
              data-aos="zoom-in"
              data-aos-delay="300"
              data-aos-duration="500"
            >
              {{ this.safety.text.ldwDesc }}
            </p>
            <!--<v-btn
              :class="'mmc-blue background'"
              class="gallery"
              data-aos="text-focus-in"
              data-aos-delay="450"
              data-aos-duration="1000"
              data-selector=".movie"
              v-ripple="{ class: 'ripple-blue' }"
            >
              <span
                class="movie"
                data-src="https://www.youtube.com/watch?v=tD3LZFNZtJI"
              ></span>
              <i class="fas fa-play"></i>
              {{ this.safety.text.ldwButton }}
            </v-btn>-->
          </div>
        </video-background>
      </div>
      <div
        class="text-with-video section fp-auto-height-responsive"
        data-anchor="RCTA"
      >
        <div class="section-container">
          <div class="section-text">
            <div class="section-wrapper">
              <h5
                class="uppercase header-sub"
                data-aos="fade-down"
                data-aos-duration="500"
              >
                {{ this.safety.text.textWitVideoSubHeader }}
              </h5>
              <h2
                class="uppercase header"
                data-aos="zoom-in"
                data-aos-delay="150"
                data-aos-duration="500"
              >
                {{ this.safety.text.textWitVideoHeader }}
              </h2>
              <h5
                class="uppercase header-sub second"
                data-aos="zoom-in"
                data-aos-delay="300"
                data-aos-duration="500"
              >
                {{ this.safety.text.textWitVideoHeaderSecond }}
              </h5>
              <p
                class="description"
                data-aos="zoom-in"
                data-aos-delay="450"
                data-aos-duration="500"
              >
                {{ this.safety.text.textWitVideoDesc }}
              </p>
              <!--<v-btn
                :class="'mmc-blue background'"
                class="gallery"
                data-aos="text-focus-in"
                data-aos-delay="600"
                data-aos-duration="1000"
                data-selector=".movie"
                v-ripple="{ class: 'ripple-blue' }"
              >
                <span
                  class="movie"
                  data-src="https://www.youtube.com/watch?v=aHaXZyTEGFo"
                ></span>
                <i class="fas fa-play"></i>
                {{ this.safety.text.ldwButton }}
              </v-btn>-->
              <div
                class="image-background"
                data-aos="zoom-in"
                data-aos-delay="600"
                data-aos-duration="1000"
                :style="{
                  backgroundImage:
                    'url(' +
                    require('@/assets/images/safety/rcta-image.jpg') +
                    ')'
                }"
              ></div>
            </div>
          </div>
          <div class="section-video">
            <div class="section-wrapper">
              <video-background
                :src="require('@/assets/videos/car.mp4')"
                :poster="require('@/assets/images/safety/rcta-background.jpg')"
                :autoplay="false"
                :loop="false"
                @ready="pauseOnStart('sawc')"
                @ended="endedVideo('sawc')"
                ref="sawc"
                data-ref="sawc"
              ></video-background>
            </div>
          </div>
        </div>
      </div>
      <div
        class="movie-section section fp-auto-height-responsive"
        data-anchor="AHB"
      >
        <video-background
          :src="require('@/assets/videos/hb.mp4')"
          :poster="require('@/assets/images/safety/ahb-background.jpg')"
          :autoplay="false"
          :loop="false"
          @ready="pauseOnStart('ahb')"
          @ended="endedVideo('ahb')"
          ref="ahb"
          data-ref="ahb"
        >
          <div class="section-wrapper">
            <h5
              class="uppercase header-sub"
              data-aos="fade-down"
              data-aos-duration="500"
            >
              {{ this.safety.text.ahbSubHeader }}
            </h5>
            <h2
              class="uppercase header"
              data-aos="zoom-in"
              data-aos-delay="150"
              data-aos-duration="500"
            >
              {{ this.safety.text.ahbHeader }}
            </h2>
            <p
              class="description"
              data-aos="zoom-in"
              data-aos-delay="300"
              data-aos-duration="500"
            >
              {{ this.safety.text.ahbDesc }}
            </p>
            <!--<v-btn
              :class="'mmc-blue background'"
              class="gallery"
              data-aos="text-focus-in"
              data-aos-delay="600"
              data-aos-duration="1000"
              data-selector=".movie"
              v-ripple="{ class: 'ripple-blue' }"
            >
              <span
                class="movie"
                data-src="https://www.youtube.com/watch?v=2VHsMgFxhnU&list=PLm9Cn8ONdBdjnIfFTEU-Ino19tvsNaGlV&index=32"
              ></span>
              <i class="fas fa-play"></i>
              {{ this.safety.text.ldwButton }}
            </v-btn>-->
          </div>
        </video-background>
      </div>
      <div
        class="text-two-images section fp-auto-height-responsive"
        data-anchor="more"
      >
        <div class="section-container">
          <div class="section-wrapper">
            <h5
              class="uppercase header-sub"
              data-aos="fade-down"
              data-aos-duration="500"
            >
              {{ this.safety.text.advancedSubHeader }}
            </h5>
            <h2
              class="uppercase header"
              data-aos="zoom-in"
              data-aos-delay="150"
              data-aos-duration="500"
            >
              {{ this.safety.text.advancedHeader }}
            </h2>
            <h3
              class="header-pref text-uppercase"
              data-aos="zoom-in"
              data-aos-delay="300"
              data-aos-duration="500"
            >
              {{ this.safety.text.advancedEasy }}
            </h3>
            <p
              class="description"
              data-aos="zoom-in"
              data-aos-delay="450"
              data-aos-duration="500"
            >
              {{ this.safety.text.advancedEasyDesc }}
            </p>
            <h3
              class="header-pref text-uppercase"
              data-aos="zoom-in"
              data-aos-delay="600"
              data-aos-duration="500"
            >
              {{ this.safety.text.advancedMode }}
            </h3>
            <p
              class="description"
              data-aos="zoom-in"
              data-aos-delay="750"
              data-aos-duration="500"
            >
              {{ this.safety.text.advancedModeDesc }}
            </p>
            <h3
              class="header-pref text-uppercase"
              data-aos="zoom-in"
              data-aos-delay="900"
              data-aos-duration="500"
            >
              {{ this.safety.text.advancedPower }}
            </h3>
            <p
              class="description"
              data-aos="zoom-in"
              data-aos-delay="1050"
              data-aos-duration="500"
            >
              {{ this.safety.text.advancedPowerDesc }}
            </p>
          </div>
        </div>
        <div class="side-gallery gallery" data-selector="div">
          <div
            :data-aos-delay="index * 150"
            :data-src="require('@/assets/images/safety/' + image)"
            :key="index"
            :style="{
              backgroundImage:
                'url(' + require('@/assets/images/safety/' + image) + ')'
            }"
            data-aos="zoom-in"
            data-aos-duration="500"
            v-for="(image, index) of this.safety.text.advancedImages"
          >
            <i class="fas fa-image"></i>
          </div>
        </div>
      </div>
      <div
        class="footer section fp-auto-height-responsive"
        data-anchor="features"
      >
        <div class="section-container">
          <swiper
            :options="safety.mainSlider"
            class="swiper slider-flex"
            ref="mainSlider"
            @slideChange="updatePaginationIndex"
          >
            <swiper-slide
              :key="index"
              class="slider-item"
              v-for="(slider, index) in this.safety.text.footerSlider"
            >
              <div
                :style="{
                  backgroundImage:
                    'url(' +
                    require('@/assets/images/safety/' + slider.background) +
                    ')'
                }"
                class="background"
              ></div>
              <div class="slider-text">
                <div class="text-wrapper">
                  <h3 class="header text-uppercase">{{ slider.header }}</h3>
                  <p>{{ slider.description }}</p>
                </div>
              </div>
            </swiper-slide>
          </swiper>
          <div class="arrows">
            <i class="fas fa-angle-left" @click="prevSlide"></i>
            <i class="fas fa-angle-right" @click="nextSlide"></i>
          </div>
          <div class="dots">
            <div
              class="dot"
              :key="index"
              :class="
                index === safety.mainSliderActiveIndex ? 'current-slide' : ''
              "
              @click="goToPage(index)"
              v-for="(dot, index) in this.safety.text.footerSlider"
            ></div>
          </div>
        </div>
        <Footer></Footer>
      </div>
    </full-page>
  </div>
</template>

<script>
import Footer from "@/components/Footer.vue";
import FullPage from "vue-fullpage.js/src/FullPage.vue";
import VideoBackground from "vue-responsive-video-background-player";
import "swiper/dist/css/swiper.css";

import { swiper, swiperSlide } from "vue-awesome-swiper";
import { mapGetters, mapMutations } from "vuex";

export default {
  name: "Safety",
  data: function() {
    return {
      options: {
        licenseKey: "3AAF9650-2EB641C5-91E1ED66-B5D30F2B",
        scrollBar: true,
        verticalCentered: false,
        menu: ".page-navbar ul",
        responsiveWidth: 767,
        responsiveHeight: 650,
        scrollingSpeed: 0,
        loopTop: true,
        loopBottom: true,
        paddingTop: 0,
        paddingBottom: 0,
        onLeave: this.onLeave
      }
    };
  },
  components: {
    VideoBackground,
    swiper,
    swiperSlide,
    FullPage,
    Footer
  },
  computed: {
    ...mapGetters({
      safety: "safety",
      header: "header"
    })
  },
  methods: {
    ...mapMutations({
      changeSliderPage: "changeSliderPage",
      changeSafetyRoadSliderPage: "changeSafetyRoadSliderPage",
      changeSafetyAllSliderPage: "changeSafetyAllSliderPage"
    }),
    updateHomeHeaderSize() {
      this.header.homeHeaderYSize = document.querySelector(
        ".subpage-header"
      ).offsetHeight;
    },
    moveToSection(index) {
      this.$refs.fullpage.api.moveTo(index + 1);
    },
    prevSlide() {
      this.$refs.mainSlider.swiper.slidePrev();
      this.updatePaginationIndex();
    },
    nextSlide() {
      this.$refs.mainSlider.swiper.slideNext();
      this.updatePaginationIndex();
    },
    goToSafetyRoadPage(value, ref) {
      const activeSlide = document
        .querySelector(
          'div[data-anchor="ACC"] .swiper-slide-active .vue-responsive-videobg'
        )
        .getAttribute("data-ref");
      this.$refs[activeSlide].player.pause();
      this.$refs[ref].player.play();
      this.$refs.safetyRoad.swiper.slideTo(value);
      this.changeSafetyRoadSliderPage(this.$refs.safetyRoad.swiper.realIndex);
    },
    goToSafetyAllPage(value, ref) {
      const activeSlide = document
        .querySelector(
          'div[data-anchor="ACC"] .swiper-slide-active .vue-responsive-videobg'
        )
        .getAttribute("data-ref");
      this.$refs[activeSlide].player.pause();
      this.$refs[ref].player.play();
      this.$refs.safetyAll.swiper.slideTo(value);
      this.changeSafetyAllSliderPage(this.$refs.safetyAll.swiper.realIndex);
    },
    goToPage(value) {
      this.$refs.mainSlider.swiper.slideToLoop(value);
      this.updatePaginationIndex();
    },
    updatePaginationIndex() {
      this.changeSliderPage(this.$refs.mainSlider.swiper.realIndex);
    },
    sliderVideoStart(ref, slider) {
      const activeSlide = document.querySelector(".fp-section.active");

      if (activeSlide) {
        const slide = document.querySelector(
          ".fp-section.active .swiper-slide-active .vue-responsive-videobg"
        );

        if (slide !== null) {
          if (ref === slide.getAttribute("data-ref")) {
            this.$refs[ref].player.play();
          }
        }
      }
    },
    pauseOnStart(name) {
      const activeSlide = document.querySelector(
        ".fp-section.active .vue-responsive-videobg"
      );

      if (activeSlide !== null) {
        if (name === activeSlide.getAttribute("data-ref"))
          this.$refs[name].player.play();
      }
    },
    endedVideo(name) {
      this.$refs[name].player.play();
    },
    onLeave(origin, destination, direction) {
      if (
        destination.item.classList.contains("movie-section") ||
        destination.item.classList.contains("text-with-video")
      ) {
        const ref = destination.item
          .querySelector(".vue-responsive-videobg")
          .getAttribute("data-ref");
        this.$refs[ref].player.play();
      } else if (destination.item.classList.contains("text-and-slide")) {
        const ref = destination.item
          .querySelector(".swiper-slide-active")
          .firstChild.getAttribute("data-ref");
        this.$refs[ref].player.play();
      }

      if (
        origin.item.classList.contains("movie-section") ||
        origin.item.classList.contains("text-with-video")
      ) {
        const ref = origin.item
          .querySelector(".vue-responsive-videobg")
          .getAttribute("data-ref");
        this.$refs[ref].player.pause();
      } else if (origin.item.classList.contains("text-and-slide")) {
        const ref = origin.item
          .querySelector(".swiper-slide-active")
          .firstChild.getAttribute("data-ref");
        this.$refs[ref].player.pause();
      }
    }
  },
  mounted() {
    const galleries = document.getElementsByClassName("gallery");
    const body = document.querySelector("body");

      Array.prototype.forEach.call(galleries, e => {
        window.lightGallery(e, {
          selector: e.getAttribute("data-selector"),
          download: false,
          autoplay: false,
          videoMaxWidth: "1920px"
        });
      });

    body.classList.add("no-overflow");

    this.$refs.mainSlider.swiper.update();

    this.updateHomeHeaderSize();
    window.addEventListener("resize", this.updateHomeHeaderSize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateHomeHeaderSize);
  }
};
</script>

<style lang="scss" scoped>
@import "src/styles/mixins";
@import "src/styles/page-navbar";
@import "src/styles/footer-subpage";
@import "src/styles/text-two-images";
@import "src/styles/movie-section";
@import "src/styles/text-with-video";

.subpage-header {
  @include set-background(no-repeat, center center, cover);
  background-image: url("../assets/images/safety/header-background.jpg");
  padding: var(--page-offset);

  .section-container {
    @include display-flex(flex, wrap);
    height: 100%;
    padding: var(--page-offset);
    align-content: center;

    .section-wrapper {
      width: 75%;

      @media screen and (max-width: $screen-sm) {
        width: 100%;
      }

      .header {
        span {
          color: $mmc-blue;
        }
      }

      .description {
        width: 50%;

        @media screen and (max-width: $screen-md) {
          width: 75%;
        }

        @media screen and (max-width: $screen-sm) {
          width: 100%;
        }
      }
    }
  }
}

.text-and-slide {
  .section-container {
    @include display-flex(flex, wrap);
    @include size-flex(100%);
    height: 100%;
  }

  .section-text {
    @include size-flex(100%);
    padding: var(--page-offset) calc(2 * var(--page-offset)) 0;

    &.text-right {
      .description {
        margin-left: 50%;

        @media screen and (max-width: $screen-md) {
          margin-left: 25%;
        }

        @media screen and (max-width: $screen-sm) {
          margin-left: 0%;
        }
      }
    }

    .header {
      color: $black;
      margin-top: 0 !important;

      @media screen and (max-height: $screen-height-mlg) {
        font-size: 1.75rem;
        margin-bottom: 1.5rem;
      }

      @media screen and (max-width: $screen-md) {
        font-size: 1.75rem;
        margin-bottom: 1.5rem;
      }
    }

    .header-sub {
      color: $black;
      margin-bottom: 2rem;
    }

    .description {
      color: $slider-description;
      width: 50%;

      @media screen and (max-height: $screen-height-mlg) {
        line-height: 1.25;
        font-size: 0.9rem;
        margin-bottom: 1.25rem !important;
      }

      @media screen and (max-width: $screen-md) {
        width: 75%;
        line-height: 1.25;
        font-size: 0.9rem;
        margin-bottom: 1.25rem !important;
      }

      @media screen and (max-width: $screen-sm) {
        width: 100%;
      }
    }
  }

  .buttons {
    @include display-flex(flex, wrap);
    margin-bottom: 2rem;
    justify-content: flex-end;

    &.flex-start {
      justify-content: flex-start;
    }

    .v-btn {
      height: auto !important;
      padding: 0.5rem 1rem !important;
      font-weight: 500 !important;
      margin-right: 1rem !important;
      white-space: normal !important;

      @media screen and (max-height: $screen-height-mlg) {
        letter-spacing: 0 !important;
        font-size: 0.8rem !important;
      }

      @media screen and (max-width: $screen-lg) {
        letter-spacing: 0 !important;
        font-size: 0.8rem !important;
      }

      @media screen and (max-width: $screen-md) {
        font-size: 1.75rem;
        margin-bottom: 1.5rem;
      }

      @media screen and (max-width: $screen-sm) {
        @include size-flex(calc(100%));
      }

      &:last-of-type {
        margin-right: 0 !important;
      }

      &.only-text {
        color: $black !important;
        box-shadow: none;
        border-color: transparent;
      }

      span {
        flex: 0 0 auto !important;
      }

      @media screen and (max-width: $screen-xs) {
        box-sizing: border-box !important;
        margin-right: 0 !important;
      }
    }
  }

  .section-slider {
    @include display-flex(flex, wrap);
    @include size-flex(100%);
    align-self: flex-end;

    .slider-item {
      min-height: 45vh;
      width: 100%;

      @media screen and (max-width: $screen-lg) {
        min-height: 35vh;
      }

      @media screen and (max-width: $screen-sm) {
        min-height: 50vh;
      }

      .vue-responsive-videobg {
        @include display-flex(flex, wrap);
        @include size-flex(100%);
        align-self: flex-end;
        height: 90%;
        overflow: visible;

        @media screen and (max-width: $screen-sm) {
          height: 65%;
        }
      }

      .videobg-content {
        .p-bold {
          @include z-index(relative, 1);
          padding: 0 calc(2 * var(--page-offset));
          margin: 0;
          top: -2rem;
          width: 100vw;
          box-sizing: border-box;

          &.right {
            text-align: right;
          }

          @media screen and (max-width: $screen-sm) {
            top: -5rem;
          }

          b {
            @include font-size-color(1rem, $slider-description !important);

            @media screen and (max-width: $screen-md) {
              font-size: 0.8rem;
            }
          }
        }
      }
    }
  }
}

.text-two-images {
  @media screen and (max-height: $screen-height-md) {
    .header-pref {
      font-size: 1.15rem;
    }

    .description {
      font-size: 0.8rem !important;
      line-height: 1.15 !important;
      margin-bottom: 1.5rem !important;
    }
  }

  @media screen and (max-width: $screen-lg) {
    .header-pref {
      font-size: 1.15rem;
    }

    .description {
      font-size: 0.8rem !important;
      line-height: 1.2 !important;
      margin-bottom: 1.5rem !important;
    }
  }

  @media screen and (max-width: $screen-sm) {
    .header-pref {
      font-size: 1.5rem;
    }

    .description {
      margin-bottom: 2rem !important;
      font-size: 0.9rem !important;
    }
  }
}

.text-with-video .section-container .section-text .header-sub.second {
  color: $black !important;
  margin-bottom: 2rem !important;
}
</style>
